import { Component, ChangeDetectionStrategy, Input, TemplateRef } from '@angular/core';
import { SizeRange } from '@bazis/shared/models/base.types';

@Component({
    selector: 'bazis-item-with-icon-value',
    templateUrl: './item-with-icon-value.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisItemWithIconValueComponent {
    // @Input() infiniteListTpl: TemplateRef<any>;

    // @Input() selectedValueTpl: TemplateRef<any>;

    @Input() item;

    @Input() iconSize: SizeRange = SizeRange.huge;
}
